import { ReactNode } from 'react';
import { Clickable, Col } from 'common/components/Flex';
import { ClickableProps } from 'common/components/Flex/ClickableFlex.tsx';

type Props = Omit<ClickableProps, 'className'> & {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  classes?: {
    root?: string;
    title?: string;
    icon?: string;
    subtitle?: string;
  };
  icon?: ReactNode;
  'data-testid'?: string;
};

const ActionButton = ({ onClick, title, subtitle, children, classes, icon, ...rest }: Props) => {
  return (
    <Clickable
      data-testid={rest['data-testid']}
      onClick={onClick}
      row
      align="center"
      justify="start"
      className={'gx-20 '.concat(classes?.root ?? '')}
      {...rest}
    >
      {icon || children}
      <Col align="start" justify="center" className="gy-0">
        <p className={'body-md bold '.concat(classes?.title ?? ' ')}>{title}</p>
        {subtitle && <p className={'body-sm bold color-tertiary '.concat(classes?.subtitle ?? ' ')}>{subtitle}</p>}
      </Col>
    </Clickable>
  );
};

export default ActionButton;
